import StringExtensions from "./extensions/string.js";
StringExtensions();

window.getVerificationToken = () => ({
  RequestVerificationToken: document.getElementsByName(
    "__RequestVerificationToken"
  )[0].value,
});

// Lazysizes
import "lazysizes";

import "flowbite";

// Alpine bootup
import Alpine from "./alpine/imports.js";

Alpine();
